// extracted by mini-css-extract-plugin
module.exports = {"admin":"admin_admin__3rjfG","search":"admin_search__2G81D","searchBox":"admin_searchBox__40lX_"};